import HTTP from "@/plugins/http";
import utils from "@/resources/utils";
import validationStatusCode from "@/resources/validation_status_code";

const getSpeciesWithoutPagination = async token =>
  validationStatusCode(
    await HTTP.get(`/species/`, {
      headers: utils.headerAuth(token)
    })
  );

const getSpecies = async (token, page) =>
  validationStatusCode(
    await HTTP.get(`/species/?pagination=true&page=${page}`, {
      headers: utils.headerAuth(token)
    })
  );

const getSpecie = async (id, token) =>
  validationStatusCode(
    await HTTP.get(`/species/${id}`, {
      headers: utils.headerAuth(token)
    })
  );

const createSpecie = async (Specie, token) =>
  validationStatusCode(
    await HTTP.post("/species/", Specie, {
      headers: utils.headerAuth(token)
    })
  );

const updateSpecie = async (id, Specie, token) => {
  return validationStatusCode(
    await HTTP.patch(`/species/${id}/`, Specie, {
      headers: utils.headerAuth(token)
    })
  );
};

const deleteSpecie = async (id, token) =>
  validationStatusCode(
    await HTTP.delete(`/species/${id}/`, {
      headers: utils.headerAuth(token)
    })
  );

export default {
  getSpeciesWithoutPagination,
  getSpecies,
  getSpecie,
  createSpecie,
  updateSpecie,
  deleteSpecie
};
